module.exports = __webpack_public_path__ + "img/27.6.CODm.2f8327e2.png";